// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["style-fallback","style"], function() { return __webpack_require__("./assets/frontend.js"); })
__webpack_require__.O(undefined, ["style-fallback","style"], function() { return __webpack_require__("./assets/css/style.scss"); })
var __webpack_exports__ = __webpack_require__.O(undefined, ["style-fallback","style"], function() { return __webpack_require__("./assets/css/style-fallback.scss"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
